<template>
  <div class="webPdfSign">
    <div v-if="webSaveFolderId" class="topBtn">
      <el-button type="primary" size="small" @click="openDocDialog(0)">选择文件</el-button>
      <el-button type="primary" size="small" @click="openDocDialog(1)">存放目录：{{ rootPath }}</el-button>
    </div>
    <el-button v-if="!webSaveFolderId" size="small" class="middle" type="primary" icon="el-icon-plus" @click="openDocDialog(0)">选择文件</el-button>
    <webPdfSign ref="webPdfSign" :isWebPdfSign="true" :webSaveFolderId="webSaveFolderId"></webPdfSign>
  </div>
</template>

<script>
import webPdfSign from "@/CommonDP/pages/cad-client/pdfSign/index.vue";
import { openDoc } from "@/CommonDP/components/custom-dialog/index.js";
import { mapState } from "vuex";

export default {
  name: "ProjectWebPdfSign",
  components: { webPdfSign },
  data() {
    return {
      rootPath: '',
      fileIds: '',
      webSaveFolderId: ''
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj
    })
  },
  methods: {
    async openDocDialog(val) {
      const { prjId } = this.prjInfo;
      const props = {
        check: (Vo) => val === 1 ? Vo.isFolder === val : Vo.isFolder === val && Vo.fileType === 4
      };
      props.prjId = prjId;
      props.multiple = val !== 1;
      const list = await openDoc(props);
      if (val === 1) {
        this.rootPath = '项目/' + list[0].fullName;
        this.webSaveFolderId = list[0].folderId;
      } else {
        this.fileIds = list.map(e => e.folderId).join(",");
        this.$refs.webPdfSign.pdfUrl = '';
        this.$refs.webPdfSign.initFiles(this.fileIds);
        const typeIndex = list[0].fullName.lastIndexOf("/");
        const newName = list[0].fullName.substring(0, typeIndex);
        this.rootPath = '项目/' + newName;
        this.webSaveFolderId = list[0].parentId;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.webPdfSign{
  width: 100%;
  height: 100%;
  background-color: #fff;
  .topBtn{
    padding: 5px;
    position: relative;
    z-index: 999;
  }
  .middle{
    position: absolute;
    top: calc(50% - 15px);
    left: calc(50% - 45px);
  }
}
</style>
